export const parseTime = (time?: number | null | undefined) => {
  if (!time) return [];
  const hour = Math.floor(time / 3600);
  const minute = Math.floor((time % 3600) / 60);
  return [hour, minute];
};
